/* eslint-disable react/sort-comp */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

import {isNaN} from 'lodash';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import {Get} from '@/api/request';
import * as APPDATA from '@/constants/pcConstAppData';
import {consoleLog} from '@/libs/consoleHelper';
import {newLineHtml} from '@/libs/htmlHelper';

import {STEP_WIZARD} from '../../../constants/calibrationWizardConstant';

const INPUT_USER = 1;
const PROTEIN_SENSOR = 0;
const PROTEIN_REF = 1;
const BUFFER_SENSOR = 2;
// const BUFFER_REF = 3
@connect((store) => ({
  fontSize: store.setupStore.fontSize,
  lockAccess: store.setupStore.lockAccess,
  isPCRunning: store.setupStore.isPCRunning,
}))
// const CalibrationStep = ({imageSrc,saveAction,text,parameter,disable})=>(
class CalibrationStep extends React.Component {
  constructor(props) {
    super(props);
    this.switchImage = this.switchImage.bind(this);
    this.state = {
      currentImage: 0,
      refWeight: APPDATA.EMPTY_FIELD,
      // IsProteinTubeAttached: undefined,
      // IsBufferTubeAttached: undefined,
      // classTubeDetectedAlert: 'alert-div tube-detected-warning not-visibile-div ',
    };
    this.mounted = true;
    this._isImgMoreThan1 = undefined;
    this._isShowTubeDetectedAlert = undefined;
    this.successGetTubeSensorAvailable = this.successGetTubeSensorAvailable.bind(this);
    this.successGetIsTubeAttach = this.successGetIsTubeAttach.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    if (this.props.parameter[PROTEIN_REF].value !== -1) {
      this.setState({
        refWeight: this.props.parameter[PROTEIN_REF].value,
      });
    }
    // this.loadImage()
    if (this.props.imageSrc.length > 1) {
      this._isImgMoreThan1 = setInterval(this.switchImage, 1500);
    }
    if (this.props.calibrationStep === STEP_WIZARD.NoTubeCalibration) {
      Get(APPDATA.API.IS_TUBE_SENSOR_AVAILABLE, '', this.successGetTubeSensorAvailable, '');
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    if (this.props.imageSrc.length > 1) {
      if (typeof this._isImgMoreThan1 !== 'undefined') clearInterval(this._isImgMoreThan1);
    }
    // if (this.props.calibrationStep === STEP_WIZARD.NoTubeCalibration) {
    if (typeof this._isShowTubeDetectedAlert !== 'undefined') clearInterval(this._isShowTubeDetectedAlert);
    // }
  }

  switchImage() {
    if (this.mounted === true) {
      if (this.state.currentImage < this.props.imageSrc.length - 1) {
        this.setState({
          // eslint-disable-next-line react/no-access-state-in-setstate
          currentImage: this.state.currentImage + 1,
        });
      } else {
        this.setState({
          currentImage: 0,
        });
      }
    }
    return this.state.currentImage;
  }

  // True is All input is number
  // False is there is an input not number
  // eslint-disable-next-line class-methods-use-this
  checkAllInputIsNumber(parameter) {
    if (!parameter) return false;
    for (let i = 0; i < parameter.length; i++) {
      if (!isNaN(parameter[i].value)) return false;
    }
    return true;
  }

  onChange(e) {
    if (e.type) {
      switch (e.type) {
        case APPDATA.FIELD_NAME.CALIBRATION_WEIGHT:
          if (this.mounted === true) {
            this.setState({
              refWeight: e.value,
            });
          }
          this.props.saveRefAction(e.value);
          break;
        default:
          break;
      }
    }
  }

  onClick(e) {
    let value = null;
    let minValue = null;
    let maxValue = null;

    switch (e.currentTarget.id) {
      case APPDATA.FIELD_NAME.CALIBRATION_WEIGHT:
        value = this.state.refWeight;
        minValue = 20;
        // minValue = 25;
        maxValue = 150;
        break;
      default:
        break;
    }

    let valueNumpad = 0;
    // eslint-disable-next-line no-unused-expressions
    value === APPDATA.EMPTY_FIELD ? (valueNumpad = 0) : (valueNumpad = value);
    this.props.dispatch(
      modalActions.showModal({
        modalHeader: e.currentTarget.id,
        value: valueNumpad,
        callback: this.onChange.bind(this),
        incrementValue: 1,
        maxDigitAfterDecimal: APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY,
        minValue,
        maxValue,
      }),
    );
  }

  successGetTubeSensorAvailable = (response) => {
    if (response.data) {
      consoleLog('Tube Sensor Available');
      this._isShowTubeDetectedAlert = setInterval(() => {
        this.checkIsTubeAttach();
      }, 500);
    } else {
      consoleLog('Tube Sensor Not Available');
    }
  };

  checkIsTubeAttach = () => {
    // this.setState({
    //   IsProteinTubeAttached: undefined,
    //   IsBufferTubeAttached: undefined,
    // });

    Get(APPDATA.API.IS_BOTTLE_PROTEIN_ATTACHED, '', this.successGetIsTubeAttach, APPDATA.KEY.ProteinTube);
    Get(APPDATA.API.IS_BOTTLE_BUFFER_ATTACHED, '', this.successGetIsTubeAttach, APPDATA.KEY.BufferTube);
  };

  // eslint-disable-next-line class-methods-use-this
  successGetIsTubeAttach = (response) => {
    // consoleLog(passingParam + " Tube Detect " + response.data)
    if (response.data) {
      // switch (passingParam) {
      //   case APPDATA.KEY.ProteinTube:
      //     this.setState({
      //       IsProteinTubeAttached: true,
      //     });
      //     break;
      //   case APPDATA.KEY.BufferTube:
      //     this.setState({
      //       IsBufferTubeAttached: true,
      //     });
      //     break;
      //   default:
      //     break;
      // }
      // this.tubeAttached(!(IsProteinTubeAttached || IsBufferTubeAttached))
    } else {
      // switch (passingParam) {
      //   case APPDATA.KEY.ProteinTube:
      //     this.setState({
      //       IsProteinTubeAttached: false,
      //     });
      //     break;
      //   case APPDATA.KEY.BufferTube:
      //     this.setState({
      //       IsBufferTubeAttached: false,
      //     });
      //     break;
      //   default:
      //     break;
      // }
    }
    // if (this.state.IsProteinTubeAttached === true || this.state.IsBufferTubeAttached === true) {
    //   this.setState({
    //     classTubeDetectedAlert: 'alert-div tube-detected-warning ',
    //   });
    // } else {
    //   this.setState({
    //     classTubeDetectedAlert: 'alert-div tube-detected-warning not-visibile-div ',
    //   });
    // }
  };

  render() {
    const {imageSrc, saveAction, text, parameter, disableSaveButton, calibrationStep} = this.props;

    const IsAllINputNumber = this.checkAllInputIsNumber(parameter);
    return (
      <div className="calibrationStep">
        <div className="col-calib-image">
          <img
            src={imageSrc[this.state.currentImage]}
            alt={imageSrc[this.state.currentImage]}
          />
          <div className="divTextLabel">{parameter[PROTEIN_SENSOR].label}</div>
          <div className="div-2col divText">
            <div>
              {parameter[PROTEIN_SENSOR].value === APPDATA.EMPTY_FIELD
                ? '-'
                : `${parameter[PROTEIN_SENSOR].value
                    .toFixed(APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY)
                    .toString()} ${parameter[INPUT_USER].unit}`}
            </div>
            <div>
              {parameter[BUFFER_SENSOR].value === APPDATA.EMPTY_FIELD
                ? '-'
                : `${parameter[BUFFER_SENSOR].value
                    .toFixed(APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY)
                    .toString()} ${parameter[INPUT_USER].unit}`}
            </div>
          </div>
        </div>
        <div className="col-calib-content">
          <div className="calibrationRow">
            {/* {text[0]} */}
            {newLineHtml(text[0])}
          </div>
          {/* {calibrationStep === STEP_WIZARD.NoTubeCalibration ?
                        <div className={classTubeDetectedAlert}>
                            <div className="icon">
                                <span className="glyphicon glyphicon-alert " />
                            </div>
                            <div className="tube-detected-warning-text">
                                {APPDATA.MESSAGES.IS_TUBE_ATTACHED.TUBE_DETECTED}
                            </div>
                        </div>
                        : <React.Fragment></React.Fragment>
                    } */}
          {calibrationStep === STEP_WIZARD.NoTubeCalibration ||
          calibrationStep === STEP_WIZARD.BufferTubeCalibration ? null : (
            <Input
              label={parameter[INPUT_USER].label}
              value={this.state.refWeight}
              unit={parameter[INPUT_USER].unit}
              onClick={this.onClick.bind(this)}
              hide={parameter[INPUT_USER].label === null}
              disabled={false}
              decimal={2}
            />
          )}
          <div className="calibrationRow">
            <button
              type="button"
              className="saveCalibrationLoadCell"
              onClick={saveAction}
              disabled={IsAllINputNumber === false ? disableSaveButton : true}
            >
              {text[2]}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function Input(props) {
  const {label, value, unit, onClick, hideField, fullWidthInput, disabled} = props;
  const valueParse = parseFloat(value);
  const inputValue = isNaN(valueParse) ? value : valueParse; // .toFixed(decimal)
  const classInputCollumn = unit === undefined ? 'div-2col divInput center' : 'div-3col divInput center';
  const classInputField = fullWidthInput ? 'inputField inputFullWitdh' : 'inputField';
  return (
    <div className={classInputCollumn}>
      {!hideField && (
        <span
          className="spanStyleInputField"
          disabled={disabled}
        >
          {' '}
          {label}{' '}
        </span>
      )}
      {!hideField && (
        <input
          className={classInputField}
          id={label}
          value={value === APPDATA.EMPTY_FIELD ? '' : inputValue}
          readOnly
          onClick={onClick}
          disabled={disabled}
        />
      )}
      {unit !== undefined && !hideField && (
        <span
          className="spanStyleInputField"
          disabled={disabled}
        >
          {' '}
          {unit}{' '}
        </span>
      )}
    </div>
  );
}
export default CalibrationStep;

CalibrationStep.propTypes = {
  imageSrc: PropTypes.array.isRequired,
  saveRefAction: PropTypes.func.isRequired,
  saveAction: PropTypes.func.isRequired,
  text: PropTypes.array.isRequired,
  parameter: PropTypes.array.isRequired,
};
